module.exports = __webpack_public_path__ + "static/media/2-item-d.7cde1b8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/2-item-d.jpg
// module id = 1160
// module chunks = 33